import { useTheme } from "@emotion/react";
import { Card, CardContainer } from "../../../../components/Card";
import { StatCard } from "../overview/OverviewHelper";
import { BarChart, LineChart } from "../../../../components/Charts";
import { formatNumber } from "../utils/StatUtils";

const StoreView = ({ filteredData = [], filterBy }) => {
    const theme = useTheme() || {};

    const getCumulativeData = () => {
        const cumulative = [];
        let runningTotals = {};

        filteredData.forEach((week = {}) => {
            const cumulativeWeek = { ...week };
            const cumulativeFields = [
                "stores_viewed",
                "stores_created",
                "store_conversion",
            ];

            cumulativeFields.forEach((field) => {
                const currentValue = Number(week[field]) || 0;
                runningTotals[field] =
                    (runningTotals[field] || 0) + currentValue;
                cumulativeWeek[`${field}_Cumulative`] = runningTotals[field];
            });

            cumulative.push(cumulativeWeek);
        });

        return cumulative;
    };

    const dataToUse =
        filterBy === "cumulativeView" ? getCumulativeData() : filteredData;

    const safeReduce = (arr, key) =>
        arr.reduce((sum, item = {}) => sum + (Number(item[key]) || 0), 0);

    const totalStoresViewed = safeReduce(dataToUse, "stores_viewed");
    const totalStoresCreated = safeReduce(dataToUse, "stores_created");
    const totalStoreConversion = safeReduce(dataToUse, "store_conversion");

    const stats = [
        {
            key: "stores_viewed",
            label: "Stores Viewed",
            value: formatNumber(totalStoresViewed || 0),
            color: theme?.palette?.graph?.cyan || "#00BCD4",
        },
        {
            key: "stores_created",
            label: "Stores Created",
            value: formatNumber(totalStoresCreated || 0),
            color: theme?.palette?.graph?.yellow || "#FFEB3B",
        },
        {
            key: "store_conversion",
            label: "Store Conversion Rate",
            value: `${(totalStoreConversion || 0).toFixed(1)}%`,
            color: theme?.palette?.graph?.magenta || "#E91E63",
        },
    ];

    return (
        <div>
            <CardContainer>
                {stats.map((stat, index) => (
                    <Card key={index}>
                        <StatCard
                            value={stat.value}
                            label={stat.label}
                            color={stat.color}
                        />
                    </Card>
                ))}
            </CardContainer>

            <CardContainer>
                <LineChart
                    data={dataToUse}
                    series={
                        filterBy === "weeklyView"
                            ? [
                                  {
                                      name: "Stores Viewed",
                                      key: "stores_viewed",
                                  },
                                  {
                                      name: "Stores Created",
                                      key: "stores_created",
                                  },
                              ]
                            : [
                                  {
                                      name: "Stores Viewed (Cumulative)",
                                      key: "stores_viewed_Cumulative",
                                  },
                                  {
                                      name: "Stores Created (Cumulative)",
                                      key: "stores_created_Cumulative",
                                  },
                              ]
                    }
                    xKey="week"
                    title="Stores Performance Trend"
                />

                <BarChart
                    data={dataToUse}
                    series={
                        filterBy === "weeklyView"
                            ? [
                                  {
                                      name: "Conversion Rate",
                                      key: "store_conversion",
                                  },
                              ]
                            : [
                                  {
                                      name: "Conversion Rate (Cumulative)",
                                      key: "store_conversion_Cumulative",
                                  },
                              ]
                    }
                    xKey="week"
                    title="Store Conversion Rate"
                />
            </CardContainer>
        </div>
    );
};

export default StoreView;
